{
  "name": "pkp-ci-elma",
  "version": "2.2.2",
  "author": "Nitrowise zrt.",
  "homepage": "https://nitrowise.com/",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --proxy-config=\"proxy-dev.conf.js\"",
    "start:prod": "ng serve --proxy-config=\"proxy-prod.conf.js\"",
    "start:no-proxy": "ng serve --proxy-config=\"\"",
    "build": "ng build",
    "build:apk:release": "ionic build --prod && ionic cap copy --no-build && ionic cap sync --no-build && cd android && gradlew.bat assembleRelease --no-daemon --quiet --stacktrace --no-watch-fs --console=plain",
    "build:aab:release": "ionic build --prod && ionic cap copy --no-build && ionic cap sync --no-build && cd android && gradlew.bat bundleRelease --no-daemon --quiet --stacktrace --no-watch-fs --console=plain",
    "build:apk:debug": "ionic build --configuration=test && ionic cap copy --no-build && ionic cap sync --no-build && cd android && gradlew.bat assembleDebug --no-daemon --quiet --stacktrace --no-watch-fs --console=plain",
    "install:apk:release": "ionic build --prod && ionic cap copy --no-build && ionic cap sync --no-build && cd android && gradlew.bat installRelease --no-daemon --quiet --stacktrace --no-watch-fs --console=plain",
    "install:apk:debug": "ionic build --configuration=test && ionic cap copy --no-build && ionic cap sync --no-build && cd android && gradlew.bat installDebug --no-daemon --quiet --stacktrace --no-watch-fs --console=plain",
    "run:android": "ionic build && npx cap sync android && ionic cap run android -l --external",
    "check:apk:signed": "jarsigner -verify -verbose -certs android/app/build/outputs/apk/release/app-release.apk",
    "check:aab:signed": "jarsigner -verify -verbose -certs android/app/build/outputs/bundle/release/app-release.aab",
    "build:test": "ng build --configuration=test --base-href=/mobile/",
    "build:prod": "ng build --configuration=production --base-href=/mobile/",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "clearapi": "if exist generated\\api rmdir /s /q generated\\api",
    "generate:api": "npm run clearapi && openapi-generator-cli generate -i swagger/api.json -g typescript-angular -o generated/api --additional-properties=ngVersion=19.0.7,npmName=restClient,supportsES6=true,npmVersion=22.13.0,withInterfaces=true,fileNaming=kebab-case,lineEnding=CRLF",
    "generate:splash": "npx capacitor-assets generate",
    "android": "ionic build && ionic cap copy --no-build && ionic cap sync && ionic cap open android",
    "bump-version": "node bump-version.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.0.0",
    "@angular/cdk": "^19.0.5",
    "@angular/common": "^19.0.0",
    "@angular/compiler": "^19.0.0",
    "@angular/core": "^19.0.0",
    "@angular/forms": "^19.0.0",
    "@angular/platform-browser": "^19.0.0",
    "@angular/platform-browser-dynamic": "^19.0.0",
    "@angular/router": "^19.0.0",
    "@capacitor/android": "6.2.0",
    "@capacitor/app": "6.0.2",
    "@capacitor/camera": "^6.0.2",
    "@capacitor/core": "6.2.0",
    "@capacitor/geolocation": "^6.0.2",
    "@capacitor/haptics": "6.0.2",
    "@capacitor/keyboard": "6.0.3",
    "@capacitor/network": "^6.0.3",
    "@capacitor/status-bar": "6.0.2",
    "@ionic/angular": "^8.0.0",
    "@ngrx/signals": "^19.2.1",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@openapitools/openapi-generator-cli": "2.18.4",
    "cordova.plugins.diagnostic": "^7.2.3",
    "ionicons": "^7.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.0.0",
    "@angular-eslint/builder": "^19.0.0",
    "@angular-eslint/eslint-plugin": "^19.0.0",
    "@angular-eslint/eslint-plugin-template": "^19.0.0",
    "@angular-eslint/schematics": "^19.0.0",
    "@angular-eslint/template-parser": "^19.0.0",
    "@angular/cli": "^19.0.0",
    "@angular/compiler-cli": "^19.0.0",
    "@angular/language-service": "^19.0.0",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "6.2.0",
    "@ionic/angular-toolkit": "^12.0.0",
    "@ionic/cli": "^7.2.1",
    "@types/jasmine": "~5.1.0",
    "@typescript-eslint/eslint-plugin": "^8.18.0",
    "@typescript-eslint/parser": "^8.18.0",
    "eslint": "^9.16.0",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-jsdoc": "^48.2.1",
    "eslint-plugin-prefer-arrow": "1.2.2",
    "eslint-plugin-unused-imports": "^4.1.4",
    "jasmine-core": "~5.1.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.6.3",
    "typescript-eslint": "^8.23.0"
  },
  "description": "An Ionic project"
}
